import { flexibleOfflineEventSchema } from '../offline-events';
import { z } from 'zod';
import { utcToZonedTime } from 'date-fns-tz';

export const offlineEventsUploadSchema = z.object({
  upload_tag: z
    .string({
      required_error: 'Invalid JSON: upload_tag is required',
      invalid_type_error: 'Invalid JSON: upload_tag is required',
    })
    .min(1, {
      message: 'Invalid JSON: upload_tag is required',
    }),
  data: z
    .array(flexibleOfflineEventSchema, {
      invalid_type_error: 'Invalid JSON: expected top level array',
    })
    .nonempty({
      message: 'Invalid JSON: expected top level array',
    }),
  autoMatch: z.boolean({
    required_error:
      'Invalid JSON: must specify whether or not data is potentially unmatchable',
    invalid_type_error:
      'Invalid JSON: must specify whether or not data is potentially unmatchable',
  }),
  timezone: z
    .string({
      invalid_type_error:
        'Invalid JSON: must be a valid timezone. see https://en.wikipedia.org/wiki/List_of_tz_database_time_zones',
    })
    .min(1, {
      message:
        'Invalid JSON: must be a valid timezone. see https://en.wikipedia.org/wiki/List_of_tz_database_time_zones',
    })
    .refine(
      (val) => {
        return isNaN(utcToZonedTime(new Date(), val).getTime()) === false;
      },
      {
        message:
          'Invalid JSON: must be a valid timezone. see https://en.wikipedia.org/wiki/List_of_tz_database_time_zones',
      },
    )
    .optional(),
});

export type OfflineEventsUpload = z.infer<typeof offlineEventsUploadSchema>;

export const offlineEventsUploadValidation = (data: OfflineEventsUpload) => {
  return offlineEventsUploadSchema.passthrough().parse(data);
};
